import axiosClient from "./axiosClient";

const serviceUrl = "core-manager/authentication/sso/web";

const ssoApi = {
  login: async (params) => {
    const url = serviceUrl + `/login`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  refreshToken: async (params) => {
    const url = serviceUrl + `/refresh_token`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  logOut: async () => {
    const url = serviceUrl + `/logout`;
    const refresh_token = localStorage.getItem("refreshToken");
    const params = { refresh_token: refresh_token };
    const response = await axiosClient.post(url, {}, { params: params });
    return response;
  },
};

export default ssoApi;
